import { DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface ProjectFeatureState {
    [index: string]: AdditionalFeature;
}

export interface AdditionalFeature {
    id: number;
    featureKey: string;
    featureName: string;
    description: string;
}

export interface UIAdditionalFeature extends AdditionalFeature {
    enable_new_feature: boolean | null;
    is_enabled: boolean;
    project_id?: number;
}

export interface AdditionalFeatureData {
    id: string;
    feature_key: string;
    feature_name: string;
    description: string;
}

export class AdditionalFeatureHelper extends DbHelper<AdditionalFeature, AdditionalFeatureData> {
    static readonly importMap: ImportMap<AdditionalFeature, AdditionalFeatureData> = [
        { i: "id", o: "id" },
        { i: "feature_key", o: "featureKey" },
        { i: "feature_name", o: "featureName" },
        { i: "description", o: "description" },
    ];

    static fromDbObject(feature): AdditionalFeature {
        return ClassImporterExporter.importObject(feature, AdditionalFeatureHelper.importMap);
    }

    static toDbObject(obj: AdditionalFeature): AdditionalFeatureData {
        return ClassImporterExporter.exportObject(obj, this.importMap, false);
    }

    constructor() {
        super();
    }

    fromDbObject(feature: AdditionalFeatureData): AdditionalFeature {
        return AdditionalFeatureHelper.fromDbObject(feature);
    }

    toDbObject(feature: AdditionalFeature): AdditionalFeatureData {
        return AdditionalFeatureHelper.toDbObject(feature);
    }
}

export class AssignedProjectFeature {
    projectId: number;
    featureId: number;
}

export class AssignedProjectFeatureData {
    project_id: number;
    feature_id: number;
}

export class AssignedProjectFeatureHelper extends DbHelper<AssignedProjectFeature, AssignedProjectFeatureData> {
    static readonly importMap: ImportMap<AssignedProjectFeature, AssignedProjectFeatureData> = [
        { i: "feature_id", o: "featureId" },
        { i: "project_id", o: "projectId" },
    ];

    static fromDbObject(data): AssignedProjectFeature {
        return ClassImporterExporter.importObject(data, AssignedProjectFeatureHelper.importMap);
    }

    static toDbObject(obj: AssignedProjectFeature): AssignedProjectFeatureData {
        return ClassImporterExporter.exportObject(obj, this.importMap, false);
    }

    constructor() {
        super();
    }

    fromDbObject(data: AssignedProjectFeatureData): AssignedProjectFeature {
        return AssignedProjectFeatureHelper.fromDbObject(data);
    }

    toDbObject(data: AssignedProjectFeature): AssignedProjectFeatureData {
        return AssignedProjectFeatureHelper.toDbObject(data);
    }
}
